import { Box, makeStyles } from '@material-ui/core';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { SButton, SFormikTextfield, SText } from '@setvi/shared/components';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
  dialogWrapper: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    width: '600px',
    maxWidth: '90vw',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3, 3, 2, 3)
  },
  content: {
    padding: theme.spacing(0, 3, 3, 3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 3, 3, 3)
  },
  closeButton: {
    padding: 0,
    color: '#151920'
  },
  cancelButton: {
    color: '#606978',
    border: '1px solid #E2E2EA',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#F8F9FA'
    }
  },
  saveButton: {
    backgroundColor: '#0B6DE3',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0959C0'
    }
  }
}));

interface AddNoteDialogProps {
  itemId: string;
  itemName?: string;
  note?: string;
  onClose: () => void;
  onSave: (itemId: string, note: string) => void;
}

const validationSchema = Yup.object({
  note: Yup.string().required('Note is required')
});

export const AddNoteDialog = ({
  itemId,
  itemName,
  note = '',
  onClose,
  onSave
}: AddNoteDialogProps) => {
  const classes = useStyles();

  return (
    <Formik
      initialValues={{ note }}
      validationSchema={validationSchema}
      onSubmit={values => {
        onSave(itemId, values.note);
        onClose();
      }}>
      {({ isValid, dirty }) => (
        <Form>
          <Box className={classes.dialogWrapper}>
            {/* Header */}
            <Box className={classes.header}>
              <SText size="xl" weight="bold">
                Edit Note
              </SText>
              <IconButton
                className={classes.closeButton}
                onClick={onClose}
                size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Content */}
            <Box className={classes.content}>
              <SFormikTextfield
                name="note"
                label="Note"
                placeholder={
                  itemName
                    ? `For ${itemName}, add your note here...`
                    : 'Add your note here...'
                }
                required
                multiline
                minRows={4}
                maxRows={8}
              />
            </Box>

            {/* Footer */}
            <Box className={classes.footer}>
              <SButton
                variant="outlined"
                onClick={onClose}
                className={classes.cancelButton}>
                Cancel
              </SButton>
              <SButton
                type="submit"
                variant="contained"
                disabled={!isValid || !dirty}
                className={classes.saveButton}>
                Save
              </SButton>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
};
